import React from 'react'
import { bindActionCreators } from 'redux'
import { Redirect } from 'react-router-dom'
import { connect } from 'react-redux'
import { login } from '../../modules/admin'
import './login.scss'

const emailText = "Email";
const loginText = "Login";
const errorText = "Error";
const welcomeText = "Welcome";
const loadingText = "Loading";
const passwordText = "Password";
const tryAgainText = "Try again";

class Login extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      email: "",
      password: ""
    }
  }

  handleChange = (property, { target }) => {
    this.setState({
      [property]: target.value
    })
  }

  getText = () => {
    if (this.props.requestFailed) {
      return errorText;
    } else if (this.props.requestLoading) {
      return loadingText;
    } else {
      return welcomeText;
    }
  }

  render () {
    if (this.props.userLoggedIn) {
      return <Redirect to='/'/>;
    }

    return (
      <div className="loginPage">
        <div className="login">
          <div className="titleText">{this.getText()}</div>
          <div>
            <div className="inputWrapper">
              <input
                type="text"
                value={this.state.email}
                disabled={this.props.requestLoading}
                onChange={(e) => this.handleChange('email', e)}
                placeholder={emailText}
              />
            </div>
            <div className="inputWrapper">
              <input
                type="password"
                value={this.state.password}
                disabled={this.props.requestLoading}
                onChange={(e) => this.handleChange('password', e)}
                placeholder={passwordText}
              />
            </div>
          </div>
          <div className="buttonWrapper" onClick={() => this.props.login(this.state)}>
            {this.props.requestFailed ? tryAgainText : loginText}
          </div>
        </div>
      </div>
    )
  }
}


const mapStateToProps = ({ admin }) => ({
  userLoggedIn: admin.userLoggedIn,
  requestFailed: admin.requestFailed,
  requestLoading: admin.requestLoading,
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      login
    },
    dispatch
  )

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Login)
